var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDocs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.805,
    height: 18.124,
    viewBox: "0 0 13.805 18.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4e4e4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.593,18.124h10.62a1.6,1.6,0,0,0,1.593-1.593V5.31H71.089A1.6,1.6,0,0,1,69.5,3.717V0h-6.9A1.6,1.6,0,0,0,61,1.593V16.531A1.6,1.6,0,0,0,62.593,18.124ZM64.717,7.469h6.372a.531.531,0,1,1,0,1.062H64.717a.531.531,0,0,1,0-1.062Zm0,2.124h6.372a.531.531,0,1,1,0,1.062H64.717a.531.531,0,0,1,0-1.062Zm0,2.124h6.372a.531.531,0,1,1,0,1.062H64.717a.531.531,0,0,1,0-1.062Zm0,2.124h4.248a.531.531,0,1,1,0,1.062H64.717a.531.531,0,0,1,0-1.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M331.531,12.726h3.406L331,8.789v3.406A.531.531,0,0,0,331.531,12.726Z",
    transform: "translate(-260.442 -8.478)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocs);
export default __webpack_public_path__ + "static/media/google-docs.076935821bc8a2635eee026306806870.svg";
export { ForwardRef as ReactComponent };